import React from "react";
import PropTypes from "prop-types";
import { Row } from "antd";
import "./styles.css";

const HeaderRightItemsWrapper = (props) => {
  const { children, ...rest } = props;
  return (
    <Row
      gutter={[16, 16]}
      justify="end"
      className="right_header_items"
      {...rest}
    >
      {children}
    </Row>
  );
};

HeaderRightItemsWrapper.defaultProps = {
  children: null,
};

HeaderRightItemsWrapper.propTypes = {
  children: PropTypes.element,
};

export default HeaderRightItemsWrapper;
